module.exports = __webpack_public_path__ + "static/TripleThreat-Hero-a83539d6a6949a44e6bf9f6b4bbcef4b.jpg";